var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{staticClass:"back"},[_c('slid-bar-component'),_c('v-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }